(function($, Drupal) {
  'use strict';

  Drupal.behaviors.admin_ui = {
    attach: function(context, settings) {
      let $admin_toggle = $('#toolbar-item-administration', context);

      $admin_toggle.once('toggling-admin-bar').on('click', function() {
        $('body').toggleClass('admin-bar-closed');
      });
    }
  };
})(jQuery, Drupal);
